import router from "@/router/index";
import axios from "axios";
import type { AxiosError, AxiosResponse } from "axios";

let apiConfig = {
  baseURL:
    import.meta.env.VITE_API_SERVER_URL +
    import.meta.env.VITE_EDUAPP_PUBLICAPI_URL,
  //   defaultURL: import.meta.env.VITE_API_SERVER_URL,
  withCredentials: true,
};

const EduAppApiPublic = axios.create(apiConfig);

EduAppApiPublic.interceptors.response.use(
  function (response: AxiosResponse) {
    return response;
  },
  function (error: AxiosError) {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          router.push({ path: "/error/400" });
          break;
        /*
			case 401:
				router.push({ path: "/error/401" });
				break;*/
        case 402:
          router.push({ path: "/error/402" });
          break;
        case 403:
          router.push({ path: "/error/403" });
          break;
        case 404:
          router.push({ path: "/error/404" });
          break;
        case 405:
          router.push({ path: "/error/405" });
          break;
          // Handle unexpected status codes if needed
          console.error(`Unexpected error status: ${error.response?.status}`);
          break;
      }
      // Return the error as a rejected Promise to ensure it is handled in catch blocks
      return Promise.reject(error);
    } else {
      // If no response (network error or timeout), still reject the error
      return Promise.reject(error);
    }
  }
);

export default EduAppApiPublic;
